import { TimeSlot } from '@/pages/EnergyStatisticalReport/const';
import { EchartsWithTheme, Empty, useTheme } from '@maxtropy/components';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { ShareDataWrapperContext } from '../..';
import { getChartOption } from './chart';
import styles from './index.module.scss';
import water_bg from '../../../../imgs/water_bg.png';
import { formatThousandUnitDefaultTwo, keepTwoOrLine } from '@/utils/utils';
const ElecWaterBox = () => {
  const theme = useTheme();
  const { overviewData, loading } = useContext(ShareDataWrapperContext);
  const [pieLegendData, setPieLegendData] = useState<any[]>();

  // 图表
  const chartOption = useMemo(() => {
    return getChartOption(pieLegendData);
  }, [pieLegendData]);

  useEffect(() => {
    setPieLegendData(
      [
        {
          name: '尖电费',
          level: TimeSlot.PEAK,
          value: overviewData?.electricityInfo?.summit?.cost,
          rate: overviewData?.electricityInfo?.summit?.costRatio,
          color: '#FF6D2C',
        },
        {
          name: '峰电费',
          level: TimeSlot.SHARP,
          value: overviewData?.electricityInfo?.peak?.cost,
          rate: overviewData?.electricityInfo?.peak?.costRatio,
          color: '#CE90D1',
        },
        {
          name: '平电费',
          level: TimeSlot.FLAT,
          value: overviewData?.electricityInfo?.plain?.cost,
          rate: overviewData?.electricityInfo?.plain?.costRatio,
          color: '#0DB6D9',
        },
        {
          name: '谷电费',
          level: TimeSlot.VALLEY,
          value: overviewData?.electricityInfo?.valley?.cost,
          rate: overviewData?.electricityInfo?.valley?.costRatio,
          color: '#63BC7F',
        },
      ].filter(item => item?.value !== 0)
    );
  }, [overviewData]);

  return (
    <div className={styles.elecWater_wrapper}>
      <div className={styles.elec_wrapper}>
        <div className={styles.top}>
          <div className={styles.title}>用电成本</div>
          <div className={styles.value}>
            <div className={styles.label}>占比：</div>
            <div className={styles.rate}>{keepTwoOrLine(overviewData?.electricityInfo?.chargeRatio)}%</div>
          </div>
        </div>
        <div className={styles.bottom}>
          <div className={styles.chart_wrapper}>
            <EchartsWithTheme
              empty={{
                isShowEmpty: !overviewData?.electricityInfo,
                emptyNode: <Empty />,
              }}
              loading={loading}
              type="pie"
              theme={theme}
              style={{ height: 180, width: '100%' }}
              option={chartOption}
            />
          </div>
          <div className={styles.customer_legend}>
            <div className={styles.elec_cost}>
              <div className={styles.label}>用电成本-电度电费:</div>
              <div className={styles.value}>
                {formatThousandUnitDefaultTwo(overviewData?.electricityInfo?.totalCharge)}元
              </div>
            </div>
            {(pieLegendData ?? []).map(item => (
              <div className={styles.legend_item} key={item.name}>
                <div className={styles.icon} style={{ backgroundColor: item.color }}></div>
                <div className={styles.label}>{item.name ?? '--'}</div>
                <div className={styles.value}>{formatThousandUnitDefaultTwo(item.value)}元</div>
                <div className={styles.rate}>{keepTwoOrLine(item.rate)}%</div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {overviewData?.waterInfo?.hasConfig === true && (
        <div className={styles.water_wrapper}>
          <div className={styles.top}>
            <div className={styles.title}>用水成本</div>
            <div className={styles.value}>
              <div className={styles.label}>占比：</div>
              <div className={styles.rate}>{keepTwoOrLine(overviewData?.waterInfo?.tapWaterCostRatio)}%</div>
            </div>
          </div>
          <div className={styles.bottom}>
            <img className={styles.img} src={water_bg} alt="" />
            <div className={styles.label}>自来水成本:</div>
            <div className={styles.value}>{formatThousandUnitDefaultTwo(overviewData?.waterInfo?.tapWaterCost)}元</div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ElecWaterBox;
